import {useCallback, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {SavDetailResponse} from '../../../../components/sav/Models'
import {getSavDossier, savErreur} from '../../../../components/sav/requests'

// Chargement d'un dossier SAV ; maj() accepte la réponse d'une action de l'API (fiche à jour) ou recharge.
// messagePropose : événement de message à proposer au client après une transition, reçu de l'API ou transmis par
// l'écran précédent (navigate(…, {state: {messagePropose}})).
export const useSavDossier = (id?: string) => {
  const location = useLocation()
  const [detail, setDetail] = useState<SavDetailResponse | null>(null)
  const [erreur, setErreur] = useState<string | null>(null)
  const [messagePropose, setMessagePropose] = useState<string | null>(
    (location.state as any)?.messagePropose ?? null
  )

  const recharger = useCallback(() => {
    if (!id) return
    getSavDossier(id)
      .then((d) => {
        setDetail(d)
        setErreur(null)
      })
      .catch((e) => {
        setErreur(savErreur(e, 'Dossier introuvable.'))
        toast.error(savErreur(e, 'Dossier introuvable.'))
      })
  }, [id])

  useEffect(() => {
    recharger()
  }, [recharger])

  const maj = useCallback(
    (nouveau?: SavDetailResponse) => {
      if (!nouveau) return recharger()
      setDetail(nouveau)
      if (nouveau.messagePropose) setMessagePropose(nouveau.messagePropose)
    },
    [recharger]
  )

  const fermerMessage = useCallback(() => setMessagePropose(null), [])

  return {detail, erreur, maj, messagePropose, fermerMessage}
}
